import React from 'react';
// Import Libraries
import { createRoot } from 'react-dom/client';
// Import Main component
import CartMergedNotification from '../customer_pages/_cart-merged-notification/cart-merged-notification';

createRoot(document.getElementById('cart-merged-notification')).render(
  <CartMergedNotification />,
);
